<div class="dialog-header ontop" style="font-size: xx-large">
  <h3 class="header-warning" matDialogTitle>{{ confirmMessage }}</h3>
  <button class="close-button" tabindex="-1" (click)="close(false)">
    <mat-icon
      role="img"
      fonticon="bosch-ic-alert-warning-filled"
      class="mat-icon notranslate bosch-ic-alert-warning-filled Bosch-Ic mat-icon-no-color"
      aria-hidden="true"
      data-mat-icon-type="font"
      data-mat-icon-name="bosch-ic-alert-warning-filled"
    ></mat-icon>
  </button>
</div>
<mat-dialog-content>
  <button class="button-primary" (click)="close(false)">Close</button>
</mat-dialog-content>
